const INITIAL_STATE = {
};

export default {
  namespace: 'loading',
  state: INITIAL_STATE,
  effects: {
  },
};
